export default __webpack_public_path__ + "static/media/logo_serena_minimal.3f5b80cb.svg";